
            <div class="d-flex pb-4" style="justify-content:left;" *ngIf="isAbutmentStep2NarrowSelected">
                <div>
                    <img src="abutment-displace-narrow-1.png" width="459" height="160">
                </div>
                <div style="padding-left:24px;">
                    <img src="abutment-displace-narrow-2.png" width="230" height="160">
                </div>
            </div>
            <div class="d-flex pb-4" style="justify-content:left;" *ngIf="isAbutmentStep2StraightSelected">
                <div>
                    <img src="abutment-displace-wide-1.png" width="459" height="160">
                </div>
                <div style="padding-left:24px;">
                    <img src="abutment-displace-wide-2.png" width="230" height="160">
                </div>
            </div>
            <div class="d-flex pb-4" style="justify-content:left;" *ngIf="isAbutmentStep2ConvexSelected">
                <div>
                    <img src="abutment-displace-wide-1.png" width="459" height="160">
                </div>
            </div>
            <div style="display:flex;justify-content: flex-start;gap:20px;align-items: center;padding-bottom: 20px;" *ngIf="shouldNotIdealMessageDisplay" >
                    <div><img src="exclamation.png" height="32" width="auto"></div>
                    <div style="font-style: normal;font-weight: 400;font-size: 16px;line-height: 130%;color: #000000;">Options A, B and C are not ideal for this application.</div>
            </div>
            <div style="display:flex;justify-content: flex-start;gap:20px;align-items:start;padding-bottom: 20px;" *ngIf="displayWarningMessage" >
                    <div><img src="exclamation.png" height="32" width="auto"></div>
                    <div style="font-style: normal;font-weight: 400;font-size: 16px;line-height: 130%;color: #000000;text-align: left;">The abutment does not fit through the narrow gingival canal, and therefore cannot be placed on the implant completely or without tension. This can lead to fitting problems, undesirable tissue pressure, inflammation risks or even the need for surgical expansion of the soft tissue. Choose C or D to avoid the problem.</div>
            </div>
            <div class="radio-cards-container" style="max-width: 100%; max-height: 9rem;margin-bottom: 30px;gap:15px" [style]="readonly ? 'background-color: #FAF9F9; font-size: 14px;' : ''">
                
                
                                    
                <label style="width: 18%" class="radio-card-label" (click)="onAabutmentStep3Selection('A')">
                    <input [disabled]="readonly" type="radio" name="mdcp-{{anterior}}" [checked]="shouldBeCheckedForTooth('abutmentStep3','A')"  value="A" class="hidden-radio-input" />
                    <div class="custom-radio-indicator"><div class="custom-radio-indicator-dot"></div></div>
                    <div class="d-flex" style="justify-content: center;align-items: center;flex-direction: column;min-width:105px">
                        <div class="card-icon mb-0 abutment-displace-img">
                            A
                        </div>
                        <div class="card-text abutment-displace-subinfo">Fully anatomical</div>
                    </div>
                    <div class="radio-card-overlay"></div>
                </label>
                <label style="width: 18%" class="radio-card-label" (click)="onAabutmentStep3Selection('B')">
                    <input [disabled]="readonly" type="radio" name="mdcp-{{anterior}}" [checked]="shouldBeCheckedForTooth('abutmentStep3','B')"  value="B" class="hidden-radio-input" />
                    <div class="custom-radio-indicator" data-html2canvas-ignore><div class="custom-radio-indicator-dot"></div></div>
                    <div class="d-flex" style="justify-content: center;align-items: center;flex-direction: column;min-width:105px">
                    <div class="card-icon mb-0">
                        B
                    </div>
                    <div class="card-text abutment-displace-subinfo">Fabric contouring</div>
                </div>
                    <div class="radio-card-overlay"></div>
                </label>
                <label style="width: 18%" class="radio-card-label" (click)="onAabutmentStep3Selection('C')">
                    <input [disabled]="readonly" type="radio" name="mdcp-{{anterior}}" [checked]="shouldBeCheckedForTooth('abutmentStep3','C')" value="C" class="hidden-radio-input" />
                    <div class="custom-radio-indicator"><div class="custom-radio-indicator-dot"></div></div>
                    <div class="d-flex" style="justify-content: center;align-items: center;flex-direction: column;min-width:105px">
                        <div class="card-icon mb-0">C</div>
                        <div class="card-text abutment-displace-subinfo">Tissue-supporting</div>
                    </div>
                    <div class="radio-card-overlay"></div>
                </label>
                <label style="width: 18%" class="radio-card-label" (click)="onAabutmentStep3Selection('D')">
                    <input [disabled]="readonly" type="radio" name="mdcp-{{anterior}}" [checked]="shouldBeCheckedForTooth('abutmentStep3','D')" value="D" class="hidden-radio-input" />
                    <div class="custom-radio-indicator"><div class="custom-radio-indicator-dot"></div></div>
                    <div class="d-flex" style="justify-content: center;align-items: center;flex-direction: column;min-width:105px">
                        <div class="card-icon mb-0 abutment-displace-img">
                            D
                        </div>
                        <div class="card-text abutment-displace-subinfo">Following</div>
                    </div>
                    <div class="radio-card-overlay"></div>
                </label>
                <label style="width: 18%" [class]="isOptionEActive? '':'checkbox-inactive'" class="radio-card-label" *ngIf="!isAbutmentStep2ConvexSelected" (click)="onAabutmentStep3Selection('E')">
                    <input [disabled]="!isOptionEActive" type="radio" name="mdcp-{{anterior}}" [checked]="shouldBeCheckedForTooth('abutmentStep3','E')" value="E" class="hidden-radio-input" />
                    <div class="custom-radio-indicator"><div class="custom-radio-indicator-dot"></div></div>
                    <div class="d-flex" style="justify-content: center;align-items: center;flex-direction: column;min-width:105px">
                        <div class="card-icon mb-0 abutment-displace-img">
                            E
                        </div>
                        <div class="card-text abutment-displace-subinfo">No contact with soft tissue</div>
                    </div>
                    <div class="radio-card-overlay"></div>
                </label>

            </div>

            <div class="info-divider mt-4" *ngIf="readonly"></div>

            <div class="accordion-item" [class]="readonly ? 'info-card m-0 p-0' : ''">
                <h2 class="accordion-header m-0">
                    <button [style]="readonly ? 'background-color: #FAF9F9; font-size: 14px;' : ''" class="accordion-button collapsed p-0 p-3" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#rcs-' + anterior">
                      <mat-checkbox>
                    </mat-checkbox>  
                    Apply root cross-section for all teeth
                    </button>
                </h2>
                <div id="rcs-{{anterior}}" [class]="!readonly ? 'accordion-collapse collapse' : 'accordion'" >
                    <div class="accordion-body container text-center px-3 pt-2">
                        <div style="padding-left:12px"> 
                            <div style="display:flex;flex-direction: row; background-color: #FAF9F9; border: 1px solid #E4E4E4;border-radius: 8px;width: 363px;height: 337px;gap:25px;padding:20px">
                                <div style="display:flex;flex-direction: column;max-width:90px;gap:15px">
                                    <div>
                                        <img width="90" height="213" src="Asset_Image_Gity\Apply_root_cross_section_for_all_teeth\for_front_tooth_11_12.png"> 
                                    </div>
                                    <div>
                                        11,12,13,22,31,32,41,42
                                    </div>
                                </div>
                                <div style="display:flex;flex-direction: column;max-width:90px;gap:15px">
                                    <div>
                                        <img width="90" height="213" src="Asset_Image_Gity\Apply_root_cross_section_for_all_teeth\for_side_tooth_13_14_15.png"> 
                                    </div>
                                    <div>
                                        13,14,15,23,24,25,33,34,35,43,44,45
                                    </div>
                                </div>
                                <div style="display:flex;flex-direction: column;max-width:90px;gap:15px">
                                    <div>
                                        <img width="90" height="213" src="Asset_Image_Gity\Apply_root_cross_section_for_all_teeth\for_side_tooth_16_17_18.png"> 
                                    </div>
                                    <div>
                                        16,17,18,26,27,28,36,37,38,46,47,48
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>

            </div>     


